import { Box, Theme, Typography, makeStyles, useTheme } from "@material-ui/core"
import clsx from "clsx";
import jsPDF from "jspdf";
import { AppraisalReassignmentLetterStore } from "libs/feature-documents/src/documents/stores/documentForms/appraisalReassignmentLetterStore";
import { useEffect, useRef, useState } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  documentContainer: {
    paddingTop: '32px',
    paddingLeft: '32px',
    paddingRight: '32px',
    position: 'relative',
    background: '#FFF',
    fontSize: 16,
    overFlowX: 'auto',
  },
  mb3: {
    marginBottom: 24,
  },
  mb4: {
    marginBottom: 32,
  },
  mb2: {
    marginBottom: 16,
  },
}))

const usePrintModeStyles = makeStyles((theme: Theme) => ({
  documentContainer: {
    fontSize: 12,
    padding: '32px 32px',
  },
}));

export type AppraisalReassignmentLetterPDFProps = {
  preview?: boolean;
  printMode?: boolean;
  store: AppraisalReassignmentLetterStore;
  signature;
};

export const AppraisalReassignmentLetterPDF = ({
  preview = false,
  printMode = false,
  store,
  signature,
}: AppraisalReassignmentLetterPDFProps) => {

  const theme = useTheme();
  const classes = useStyles();
  const containerRef = useRef(null);

  const [printModeContainerStyle, setPrintModeContainerStyle] = useState<any>();
  const [containerStyle, setContainerStyle] = useState<any>();
  const printModeClasses = usePrintModeStyles();

  const propertyAddress = store?.appraisalReassignmentLetterDetails?.propertyAddress;
  const lenderName = store?.appraisalReassignmentLetterDetails?.lenderAlias;
  const borrowerName = store?.appraisalReassignmentLetterDetails?.borrowerName;
  const TPOName = store?.appraisalReassignmentLetterDetails?.lenderName;

  const date = store.appraisalReassignmentLetterDetails?.signedDate ? new Date(store.appraisalReassignmentLetterDetails?.signedDate):null;

  const signDate = date ? new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(date):'Pending';

  useEffect(() => {
    const doc = new jsPDF('p', 'mm', 'a4');
    let width: any = doc.internal.pageSize.getWidth();
    let height: any = doc.internal.pageSize.getHeight();
    width = `${Math.floor(width)}mm`;
    height = `${Math.floor(height)}mm`;
    setPrintModeContainerStyle({
      margin: 'auto',
      minWidth: width,
      maxWidth: width,
      height: height,
    });
    setContainerStyle({
      margin: 'auto',
      maxWidth: theme.breakpoints.values.lg,
    });
  }, []);

  return (
    <Box id="letter">
      <div ref={containerRef} style={printMode? printModeContainerStyle : containerStyle}>
        <Box className={clsx(classes.documentContainer, printMode ? printModeClasses.documentContainer : undefined)}>
          <Typography className={classes.mb3}>
            {signDate}
          </Typography>
          <Typography className={classes.mb4}>
            To whom this may concern:
          </Typography>
          <Box className={classes.mb2}>
            <Typography>
              {propertyAddress}
            </Typography>
            <Typography>
              Borrower: {borrowerName}
            </Typography>
          </Box>
          <Typography className={classes.mb2}>
            {lenderName} hereby transfers releases the attached appraisals for the properties noted above to:
          </Typography>
          <Typography className={classes.mb2}>
            <strong>Loan Funder LLC, ISAOA/ATIMA</strong>
          </Typography>
          <Typography className={classes.mb3}>
            {lenderName} certifies that this appraisal was prepared in accordance with meets all requirements of the Appraisal Independent Requirements (AIR), is USPAP compliant.
          </Typography>
          <Typography className={classes.mb4}>
            The transferring lender, appraisal management company (AMC), appraiser selection, ordering policy and process, and the appraiser complied with all AIR, Dodd Frank, FIRREA, and Consumer Protection Acts.
          </Typography>
          <Typography className={classes.mb4}>
            Kind regards,
          </Typography>
          <Box>
            <Box display={'flex'} >
              <Box>
                <img src={signature}
                  height={120}
                />
              </Box>
            </Box>
          </Box>
          <Typography>
            {TPOName}
          </Typography>
        </Box>
      </div>
    </Box>
  )
}